//export const URI =  'http://localhost:5000/';

//export const URI = ' http://10.200.234.144:5000/'; //for local ip on mobile

//server droplet
export const URI =  '/';

const API_URL = {
   
    POST_ADMIN_LOGIN: URI + 'api/adminuser/login',
    POST_ADMIN_CREATE: URI + 'api/adminuser/create',
    GET_ADMIN_ALL: URI + 'api/adminuser/',
    DELETE_ADMIN: URI + 'api/adminuser/',

    ADMIN_CREATE_STORE : URI + 'api/store/create',
    ADMIN_MANAGE_STORE : URI + 'api/store/manage',
    ADMIN_EDIT_STORE : URI + 'api/store/edit/',
    ADMIN_DELETE_STORE : URI + 'api/store/delete/',

    ADMIN_CREATE_EMPLOYEE : URI + 'api/employee/create',
    ADMIN_MANAGE_EMPLOYEE : URI + 'api/employee/manage',
    ADMIN_EDIT_EMPLOYEE : URI + 'api/employee/edit/',
    ADMIN_DELETE_EMPLOYEE : URI + 'api/employee/delete/',


    ADMIN_TIMEREPORT_GET : URI + 'api/timereport/manage',
    ADMIN_TIMEREPORT_ADD : URI + 'api/timereport/add',
    ADMIN_TIMEREPORT_EDIT : URI + 'api/timereport/edit/',
    ADMIN_TIMEREPORT_DELETE : URI + 'api/timereport/delete/',
    ADMIN_TIMEREPORT_DOWNLOAD : URI + 'api/timereport/download',


    ADMIN_STORE_LIST : URI + 'api/store/getall-admin',


    FRONTEND_EMPLOYEE_LOGIN : URI + 'api/employee/login',
    FRONTEND_EMPLOYEE_VERIFYPIN : URI + 'api/employee/verify-pin',

    FRONTEND_EMPLOYEE_TIMEENTRY : URI + 'api/timeentry/clock',
    FRONTEND_EMPLOYEE_CURRENT_TIMEENTRY: URI + 'api/timeentry/current',

    FRONTEND_STORE_LIST : URI + 'api/store/getall',

    FRONTEND_EMPLOYEE_CHANGE_REQUEST: URI + "api/changerequest/create",
    ADMIN_MANAGE_CHANGE_REQUEST : URI + 'api/changerequest/manage',
    ADMIN_DELETE_CHANGE_REQUEST : URI + 'api/changerequest/delete/',

    FRONTEND_EMPLOYEE_TIME_SUMMARY: URI + "api/timereport/employee-summary",



 }

Object.freeze(API_URL);

export default API_URL;
